import { Icon } from "@material-ui/core";
import { KeyCode } from "Components/Autocomplete/KeyCode";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { TaskTemplateTag } from "Models/Tasks/TaskTemplateTag";
import * as React from "react";
import styles from "./TaskTemplateTagSearch.scss";

interface IProps {
    placeholder?: string;
    tags?: TaskTemplateTag[];
    className?: string;
    textboxClassName?: string;
    filter: string;
    onUpdateTags(newTags: TaskTemplateTag[]): void;
    onFilterTaskTemplateTags(filter: string): void;
    onSubmitCurrentValue(value: string): void;
}

interface IState {
    tags?: TaskTemplateTag[];
    filter: string;
}

export class TaskTemplateTagSearch extends React.Component<IProps, IState> {
    private debounceTimeoutId: number;
    private DEBOUNCE_TIMEOUT: number = 500;
    private inputRef = React.createRef<HTMLInputElement>();

    constructor(props: IProps) {
        super(props);

        this.state = {
            tags: props.tags,
            filter: props.filter
        };

        this.clearSelectionEvent = this.clearSelectionEvent.bind(this);
        this.keyDownEvent = this.keyDownEvent.bind(this);
        this.changeEvent = this.changeEvent.bind(this);
        this.tagWithNameAlreadyExists = this.tagWithNameAlreadyExists.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        if (nextProps.filter !== prevState.filter) {
            return {
                filter: nextProps.filter
            };
        }

        return null;
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        if (this.state.filter === "") {
            this.textInput.value = this.state.filter;
        }
    }

    public render() {
        return (
            <div className={`${styles.searchWrapper} ${this.props.className}`}>
                <div className={`${styles.searchbar} ${this.props.textboxClassName}`}>
                    <span className={styles.icon}><MagnifyIcon /></span>
                    {
                        this.props.tags && this.props.tags.length > 0 &&
                            this.props.tags.map((tag) => {
                                return [
                                    <div className={styles.chip} key={"div_"+tag.id}>
                                        <span id="spnSelectedTaskTemplateTagChip" key={"span_"+tag.id}>{tag.name}</span>
                                        <Icon className={styles.closeIcon} onClick={() => this.clearSelectionEvent(tag)} key={"icon_"+tag.id}>close</Icon>
                                    </div>
                                ];
                            })
                        }
                    <input id="txtTaskTemplateTagSearch" className={styles.input} placeholder={this.props.placeholder} onKeyDown={this.keyDownEvent} onChange={this.changeEvent} ref={this.inputRef}/>
                </div>
            </div>
        );
    }

    public get textInput(): HTMLInputElement {
        return this.inputRef.current! as HTMLInputElement;
    }

    public clearSelectionEvent(tag: TaskTemplateTag) {
        if (this.state.tags) {
            const newTags = this.state.tags.filter(x => x.id !== tag.id || x.name !== tag.name);
            
            this.setState({
                tags: newTags
            });

            if (this.props.onUpdateTags) {
                this.props.onUpdateTags(newTags);
            }
        }
    }

    public keyDownEvent(e: React.KeyboardEvent<HTMLInputElement>) {
        const inputValue = e.currentTarget.value;

        if (e.keyCode === KeyCode.BACKSPACE_KEY_CODE && inputValue.length === 0) {
            if (this.state.tags) {
                const tag = this.state.tags.pop();
    
                if (tag) {
                    this.clearSelectionEvent(tag);
                }
            }
        }

        if(e.keyCode === KeyCode.RETURN_KEY_CODE && inputValue.length !== 0 && !this.tagWithNameAlreadyExists(inputValue)) {
            window.clearTimeout(this.debounceTimeoutId);
            this.props.onSubmitCurrentValue(inputValue);
        }
    }

    public tagWithNameAlreadyExists(name: string): boolean {
        return this.state.tags !== undefined && this.state.tags.filter(x => x.name === name).length > 0;
    } 

    public changeEvent(e: React.FormEvent<HTMLInputElement>) {
        const inputValue = e.currentTarget.value;
        if (this.debounceTimeoutId) {
            window.clearTimeout(this.debounceTimeoutId);
        }

        const debounceFunction = () => {
            if (this.props.onFilterTaskTemplateTags) {
                this.props.onFilterTaskTemplateTags(inputValue);
            }
        };

        this.debounceTimeoutId = window.setTimeout(debounceFunction.bind(this), this.DEBOUNCE_TIMEOUT);
    }
}


// WEBPACK FOOTER //
// ./src/Components/TaskTemplateTagSelection/TaskTemplateTagSearch/TaskTemplateTagSearch.tsx